import { useCountAssignerProcessingChatSessionsQuery } from 'services';

export function useCountAssignerProcessingChatSessions(id: number) {
  const { data, isLoading } = useCountAssignerProcessingChatSessionsQuery(id, {
    skip: !id,
    refetchOnMountOrArgChange: true
  });

  return {
    data: data?.data,
    isLoading
  };
}
